import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';

import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './subMenu.module.scss';
const cx = classnames.bind(styles);

const SubMenu = () => {
  const router = useRouter();

  return (
    <div className={cx('menuArea')}>
      <Text fontStyle={FontStyle.H5_B}>MY JOBDA</Text>

      <div className={cx('up', 'menu')}>
        <Link
          className={cx('item', { selected: router.pathname === RouteUrl.MY_PAGE_APPLYING })}
          href={RouteUrl.MY_PAGE_APPLYING}
        >
          작성 중인 지원서
        </Link>
        <Link
          className={cx('item', { selected: router.pathname === RouteUrl.MY_PAGE_APPLY })}
          href={RouteUrl.MY_PAGE_APPLY}
        >
          지원현황
        </Link>
        <Link
          className={cx('item', { selected: router.pathname === RouteUrl.MY_PAGE_BOOKMARK })}
          href={RouteUrl.MY_PAGE_BOOKMARK}
        >
          북마크
        </Link>
      </div>

      <div className={cx('divider')} />

      <div className={cx('bottom', 'menu')}>
        <Link
          className={cx('item', { selected: router.pathname === RouteUrl.MY_PAGE_ACCOUNT })}
          href={RouteUrl.MY_PAGE_ACCOUNT}
        >
          계정정보 관리
        </Link>
        <Link
          className={cx('item', { selected: router.pathname === RouteUrl.MY_PAGE_PREMIUM })}
          href={RouteUrl.MY_PAGE_PREMIUM}
        >
          제휴 서비스 신청 관리
        </Link>
        <Link
          className={cx('item', { selected: router.pathname === RouteUrl.MY_PAGE_NOTICE })}
          href={RouteUrl.MY_PAGE_NOTICE}
        >
          알림 관리
        </Link>
      </div>
    </div>
  );
};

export default SubMenu;
